import React, { useRef } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

import './EventServicesSection.css';

import video1 from '../assets/file-1.mp4';
import video2 from '../assets/file-2.mp4';
import video3 from '../assets/file-4.mp4';

import bgImage1 from '../assets/offline-1.jpeg'; // Add your image for Offline Media
import bgImage2 from '../assets/event-decor.jpg';
import bgImage3 from '../assets/event-0.jpg'; // Adjust the path to your image
   // Add your image for Event Decor

function useOnScreen(ref, rootMargin = '0px') {
  const [isVisible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref, rootMargin]);

  return isVisible;
}

const EventServicesSection = () => {
  const slideLeft1 = useRef();
  const slideBottom1 = useRef();
  const slideRight1 = useRef();
  const slideLeft2 = useRef();
  const slideBottom2 = useRef();
  const slideRight2 = useRef();

  const visibleLeft1 = useOnScreen(slideLeft1, '-100px');
  const visibleBottom1 = useOnScreen(slideBottom1, '-100px');
  const visibleRight1 = useOnScreen(slideRight1, '-100px');
  const visibleLeft2 = useOnScreen(slideLeft2, '-100px');
  const visibleBottom2 = useOnScreen(slideBottom2, '-100px');
  const visibleRight2 = useOnScreen(slideRight2, '-100px');

  return (
    <section className="py-5" style={{ backgroundColor: '#0d021c' }}>
      <Container>
        <div className="text-center mb-4">
          <p className="text-muted1 small text-white">OUR SERVICES</p>
          <h1 className="fw-bold text-white">
            Our Events Services For A Seamless <br /> Experience Day.
          </h1>
          <p className="text-muted1 text-white col-lg-6 mx-auto">
           We specialize in crafting unforgettable events with precision and care. From planning and design to execution and support, our comprehensive services ensure every moment is seamless, stress-free, and tailored to your vision.
          </p>
        </div>

        <Row className="g-4">
          {/* Top Left */}
          <Col md={4} ref={slideLeft1} className={`slide-in-left ${visibleLeft1 ? 'active' : ''}`}>
            <div className="position-relative service-image-wrapper">
              <video
                src={video1}
                autoPlay
                muted
                loop
                playsInline
                className="img-fluid rounded-4 custom-video"
              />
              <div className="play-icon-wrapper">
                <div className="gradient-overlay" />
              </div>
              <div className="service-name-overlay">Corporate Events</div>
            </div>
          </Col>

          {/* Top Middle */}
         <Col md={4} ref={slideBottom1} className={`slide-in-bottom ${visibleBottom1 ? 'active' : ''}`}>
   <Card
              className="rounded-4 p-4 h-100 text-white position-relative"
              style={{
                backgroundImage: `url(${bgImage3})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="card-overlay" />
              
              <h5 className="fw-bold mt-4">Offline Media</h5>
              <p className="mb-0">CANTER activities, hoardings, and outdoor branding</p>
            </Card>
</Col>


          {/* Top Right */}
          <Col md={4} ref={slideRight1} className={`slide-in-right ${visibleRight1 ? 'active' : ''}`}>
            <div className="position-relative service-image-wrapper">
              <video
                src={video2}
              autoPlay
  muted
  loop
  playsInline
  controls={false}
                className="img-fluid rounded-4 custom-video"
              />
              <div className="play-icon-wrapper">
                <div className="gradient-overlay" />
              </div>
              <div className="service-name-overlay">Marketing Setups</div>
            </div>
          </Col>

          {/* Bottom Left (Image background) */}
          <Col md={4} ref={slideLeft2} className={`slide-in-left ${visibleLeft2 ? 'active' : ''}`}>
            <Card
              className="rounded-4 p-4 h-100 text-white position-relative"
              style={{
                backgroundImage: `url(${bgImage1})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="card-overlay" />
              
              <h5 className="fw-bold mt-4">BTL Activities</h5>
              <p className="mb-0"> Corporate ,Society and  Mall Activation</p>
            </Card>
          </Col>

          {/* Bottom Middle */}
          <Col md={4} ref={slideBottom2} className={`slide-in-bottom ${visibleBottom2 ? 'active' : ''}`}>
            <div className="position-relative service-image-wrapper">
              <video
                src={video3}
                autoPlay
  muted
  loop
  playsInline
  controls={false}
                className="img-fluid rounded-4 custom-video"
              />
              <div className="play-icon-wrapper">
                <div className="gradient-overlay" />
              </div>
              <div className="service-name-overlay">Corporates Parties</div>
            </div>
          </Col>

          {/* Bottom Right (Image background) */}
          <Col md={4} ref={slideRight2} className={`slide-in-right ${visibleRight2 ? 'active' : ''}`}>
            <Card
              className="rounded-4 p-4 h-100 text-white position-relative"
              style={{
                backgroundImage: `url(${bgImage2})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="card-overlay" />
              
              <h5 className="fw-bold mt-4">Event Decor</h5>
              <p className="mb-0">Thematic decor for social & corporate events</p>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EventServicesSection;
